import { extend, $ } from './HelperFunctions'

export class BackToTopButton {
  constructor (selectors, classes) {
    this.selectors = extend({
      footer: '[data-js-footer]',
      backToTop: '[data-js-back-to-top]'
    }, selectors)

    this.classes = extend({
      hidden: 'back-to-top-button--hidden',
      docked: 'back-to-top-button--docked'
    }, classes)
  }

  init () {
    this.addBackToTopButton()
  }

  addBackToTopButton () {
    const that = this
    const footer = $(that.selectors.footer)
    const scrollToTopBtn = $(that.selectors.backToTop)
    let timer = null

    if (scrollToTopBtn) {
      document.addEventListener('scroll', function () {
        scrollToTopBtn.classList.remove(that.classes.hidden)

        if (timer !== null) {
          clearTimeout(timer)
        }

        if (!scrollToTopBtn.classList.contains(that.classes.docked)) {
          timer = setTimeout(function () {
            scrollToTopBtn.classList.add(that.classes.hidden)
          }, 2000)
        }
      }, false)
    }

    function callback (entries) {
      // The callback will return an array of entries, even if you are only observing a single item
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          scrollToTopBtn.classList.add(that.classes.docked)
          scrollToTopBtn.classList.remove(that.classes.hidden)
        } else {
          scrollToTopBtn.classList.remove(that.classes.docked)
        }
      })
    }

    if (footer) {
      const observer = new IntersectionObserver(callback)
      observer.observe(footer)
    }
  }
}

export default BackToTopButton
